(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vendrise-pack-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vr-finder').forEach((finder) => {
    if (finder.dataset.ready === 'true') return;
    finder.dataset.ready = 'true';
    const panels = finder.querySelectorAll('[data-step]');
    const progress = finder.querySelector('.vr-finder__progress span');
    const scores = { gift: 0, collector: 0, thrill: 0 };
    const showStep = (step) => {
      panels.forEach((panel) => { panel.hidden = panel.dataset.step !== String(step); });
      progress.style.width = `${step * 33.33}%`;
    };
    finder.querySelectorAll('[data-answer]').forEach((button) => {
      button.addEventListener('click', () => {
        scores[button.dataset.answer] += 1;
        const step = Number(button.closest('[data-step]').dataset.step);
        if (step < 2) { showStep(step + 1); return; }
        const winner = Object.keys(scores).reduce((best, key) => scores[key] > scores[best] ? key : best, 'gift');
        finder.querySelectorAll('[data-result]').forEach((result) => { result.hidden = result.dataset.result !== winner; });
        showStep(3);
      });
    });
    finder.querySelector('.vr-finder__restart').addEventListener('click', () => {
      Object.keys(scores).forEach((key) => { scores[key] = 0; });
      showStep(1);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
